import {
  Box,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface LoadingOverlayProps {
  message?: string
  isFullScreen?: boolean
}

export function LoadingOverlay({ message, isFullScreen = false }: LoadingOverlayProps) {
  const { t } = useTranslation()
  return (
    <Box
      position={isFullScreen ? 'fixed' : 'absolute'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="blackAlpha.700"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={10}
    >
      <VStack gap={4}>
        <Spinner size="xl" color="brand.500" borderWidth="4px" />
        <Text color="white" fontSize="sm">
          {message ?? t('common.loading')}
        </Text>
      </VStack>
    </Box>
  )
}
